// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"b4297bae","284":"b4297bae","877":"b4297bae"}[chunkId] + ".chunk.css";
};